<aside
  class="{{ isMobileMenuOpen ? 'w-full' : 'w-0 md:w-[120px]' }} {{
        AccountType.isCtop(userInfo.accountType) ? 'bg-background-light-00' : 'bg-background-light-01'
    }} box-border sticky float-left left-0 top-0 pt-[52px] h-[calc(100vh-31px)] overflow-y-auto overflow-x-hidden border-l border-r border-divider-divider"
>
  <div class="p-4 md:p-0 h-full">

    <!-- Panel Gestor comercial -->
    <div *ngIf="isMobileMenuOpen && isCommercialSupportOpen">
      <div
        (click)="toggleCommercialSupport()"
        class="flex items-center text-primary cursor-pointer"
      >
        <app-cosentino-svg [svgName]="'chevron-left'" [size]="24"></app-cosentino-svg>
        <div class="typography-body-s-regular">{{ 'back-to-main-menu' | translate }}</div>
      </div>
      <div class="mt-4">
        <app-commercial-support />
      </div>
    </div>

    <!-- Menú principal -->
    <div
      *ngIf="!isCommercialSupportOpen"
      class="flex flex-col h-full"
    >
      <!-- Mobile: Mi perfil (primer elemento) -->
      <div
        *ngIf="isMobileMenuOpen"
        (click)="goToProfile()"
        class="{{ activeItemCode == 'profile' ? (AccountType.isCtop(userInfo.accountType) ? 'bg-primary-ctop-active text-white border-l-primary-ctop-hover' : 'text-primary bg-primary-hover border-l-primary-default') : (AccountType.isCtop(userInfo.accountType) ? 'hover:bg-primary-ctop-hover hover:text-black' : 'hover:bg-primary-hover') }} flex flex-row pl-4 gap-6 pr-1 py-2 border-l-4 border-transparent items-center cursor-pointer"
      >
        <app-cosentino-svg [svgName]="'profile'" [size]="24"></app-cosentino-svg>
        <div class="typography-body-m-regular">{{ 'my-profile' | translate }}</div>
      </div>

      <div
        *ngFor="let item of visibleMainMenuItems; trackBy: trackByMenuCode"
        (click)="onClick(item)"
        [attr.data-gtm-label]="'menu_' + item.code"
        class="{{ activeItemCode == item.code ? (AccountType.isCtop(userInfo.accountType) ? 'bg-primary-ctop-active text-white border-l-primary-ctop-hover' : 'text-primary bg-primary-hover border-l-primary-default') : (AccountType.isCtop(userInfo.accountType) ? 'hover:bg-primary-ctop-hover hover:text-black' : 'hover:bg-primary-hover') }} {{ isMobileMenuOpen ? 'flex-row pl-4 gap-6' : 'flex-col' }} flex pr-1 py-2 border-l-4 border-transparent items-center cursor-pointer"
      >
        <app-cosentino-svg [svgName]="this.menuService.getIconFileName(item, userInfo.accountType)" [size]="24"></app-cosentino-svg>
        <div class="{{ isMobileMenuOpen ? 'typography-body-m-regular' : 'typography-body-s-regular' }} text-center">{{ 'menu.' + userInfo.accountType + '.' + item.code | translate }}</div>
      </div>

      <div class="mt-auto flex flex-col gap-2">
        <div
          *ngIf="userInfo.otherServicesMenu.items.length > 0"
          (click)="goToOtherServices()"
          class="{{ activeItemCode == 'other-services' ? (AccountType.isCtop(userInfo.accountType) ? 'bg-primary-ctop-active text-white border-l-primary-ctop-hover' : 'bg-primary-hover border-l-primary-default') : (AccountType.isCtop(userInfo.accountType) ? 'hover:bg-primary-ctop-hover hover:text-black' : 'hover:bg-primary-hover') }} {{ isMobileMenuOpen ? 'flex-row pl-4 gap-6' : 'flex-col' }} flex pr-1 py-2 border-l-4 border-transparent items-center cursor-pointer"
        >
          <app-cosentino-svg [svgName]="'view-more'" [size]="24"></app-cosentino-svg>
          <div class="{{ isMobileMenuOpen ? 'typography-body-m-regular' : 'typography-body-s-regular' }} text-center">{{ 'menu.other-services' | translate }}</div>
        </div>

        <div *ngIf="isMobileMenuOpen" class="border-t border-divider-divider"></div>

        <div
          *ngIf="isMobileMenuOpen"
          (click)="toggleCommercialSupport()"
          class="{{ AccountType.isCtop(userInfo.accountType) ? 'hover:bg-primary-ctop-hover hover:text-black' : 'hover:bg-primary-hover' }} flex flex-row pl-4 gap-6 pr-1 py-2 border-l-4 border-transparent items-center cursor-pointer"
        >
          <app-cosentino-svg [svgName]="'phone'" [size]="24"></app-cosentino-svg>
          <div class="flex flex-row items-center">
            <div class="typography-body-m-regular text-center">{{ 'menu.your-commercial-advisor' | translate }}</div>
            <app-cosentino-svg [svgName]="'chevron-right'" [size]="24"></app-cosentino-svg>
          </div>
        </div>

        <!-- Mobile: Logout + Cambiar idioma -->
        <div *ngIf="isMobileMenuOpen" class="border-t border-divider-divider"></div>
        <div *ngIf="isMobileMenuOpen" class="flex flex-row py-3 items-center border-b border-divider-divider">
          
          <div (click)="logout()" class="flex flex-row items-center gap-2 cursor-pointer flex-1 pl-4 text-primary-default">
            <app-cosentino-svg [svgName]="'log-out'" [size]="20"></app-cosentino-svg>
            <span class="typography-body-m-regular text-primary-default">{{ 'home.logout' | translate }}</span>
          </div>

          <div class="w-px h-5 bg-divider-divider"></div>

          <div class="relative flex flex-row items-center gap-2 cursor-pointer flex-1 pl-4 text-text-secondary" (click)="showLangPicker = !showLangPicker">
            <app-cosentino-svg [svgName]="'language'" [size]="20"></app-cosentino-svg>
            <span class="typography-body-m-regular text-text-secondary">{{ currentLangCode }} / {{ 'menu.change-language' | translate }}</span>
            <div *ngIf="showLangPicker" class="absolute bottom-10 left-0 w-48 bg-white border border-divider-divider z-50 overflow-auto max-h-60 shadow-md">
              <div
                *ngFor="let lang of languages"
                (click)="changeLang(lang.code); $event.stopPropagation()"
                class="px-4 py-2 typography-body-m-regular cursor-pointer hover:bg-primary-hover"
              >{{ lang.label }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</aside>
